import PropTypes from 'prop-types'
import React from 'react'
import {
  CurrentlyWatchingTutorialSummaryPropTypes
} from 'components/generic/CourseSummary/propTypes'
import Tutorial from '../../generic/CourseSummary'
import './styles.css'

function CurrentlyWatching({ courses = { results: [] }, loadMore = () => {} }) {
  return (
    <section id="currently-watching-courses" className="wrapper">
      <div className="title"><h3>Recently Watched Courses</h3></div>
      <div className="courses-list">
        {courses.results.map((course) => (
          <Tutorial
            className="tutorial"
            key={`tutorial-${course.tutorial.id}`}
            slug={course.tutorial.slug}
            summary={course.tutorial.description}
            teacher={course.tutorial.artist.title}
            teacherSlug={course.tutorial.artist.slug}
            thumb={course.tutorial.photo.boxThumb}
            title={course.tutorial.title}
            isCurrentlyWatching
            new={course.tutorial.new}
          />
        ))}
      </div>
      {courses.next && (
        <div className="load-more-courses">
          <button type="button" onClick={() => loadMore()} className="load-more">
            Load More Courses
          </button>
        </div>
      )}
    </section>
  )
}

CurrentlyWatching.propTypes = {
  courses: PropTypes.shape({
    results: PropTypes.arrayOf(
      PropTypes.shape({
        ...CurrentlyWatchingTutorialSummaryPropTypes,
        confirmWatchTutorial: PropTypes.bool
      })
    ),
    count: PropTypes.number,
    next: PropTypes.string,
    previous: PropTypes.string
  }),
  loadMore: PropTypes.func
}

export default CurrentlyWatching
